export const IsPhone = "800px";